<template>
  <div class="card-body">
    <div class="row">

      <div class="form-group col-sm-2">

        <label>Id Confi Crtor Ws</label>

        <b-form-group :invalid-feedback="violations['idConfiCrtorWs']" :state="!violations['']">

          <b-form-input v-model="ssv2340ConfiCrtorWs.idConfiCrtorWs" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Cd Crtor</label>

        <b-form-group :invalid-feedback="violations['cdCrtor']" :state="!violations['']">

          <b-form-input v-model="ssv2340ConfiCrtorWs.cdCrtor" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Cd Opeda</label>

        <b-form-group :invalid-feedback="violations['cdOpeda']" :state="!violations['']">

          <b-form-input v-model="ssv2340ConfiCrtorWs.cdOpeda" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Cd Mdupr</label>

        <b-form-group :invalid-feedback="violations['cdMdupr']" :state="!violations['']">

          <b-form-input v-model="ssv2340ConfiCrtorWs.cdMdupr" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Sq Mdupr</label>

        <b-form-group :invalid-feedback="violations['sqMdupr']" :state="!violations['']">

          <b-form-input v-model="ssv2340ConfiCrtorWs.sqMdupr" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Dt Inico Vigen</label>

        <b-form-group :invalid-feedback="violations['dtInicoVigen']" :state="!violations['']">

          <date-picker v-model="ssv2340ConfiCrtorWs.dtInicoVigen" type="date" value-type="format" lang="pt-br" format="DD/MM/YYYY" placeholder="" :required="true" :readonly="false"></date-picker>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Dt Fim Vigen</label>

        <b-form-group :invalid-feedback="violations['dtFimVigen']" :state="!violations['']">

          <date-picker v-model="ssv2340ConfiCrtorWs.dtFimVigen" type="date" value-type="format" lang="pt-br" format="DD/MM/YYYY" placeholder="" :required="true" :readonly="false"></date-picker>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Dt Ultma Alter</label>

        <b-form-group :invalid-feedback="violations['dtUltmaAlter']" :state="!violations['']">

          <date-picker v-model="ssv2340ConfiCrtorWs.dtUltmaAlter" type="date" value-type="format" lang="pt-br" format="DD/MM/YYYY" placeholder="" :required="true" :readonly="false"></date-picker>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Cd Usuro Ultma Alter</label>

        <b-form-group :invalid-feedback="violations['cdUsuroUltmaAlter']" :state="!violations['']">

          <b-form-input v-model="ssv2340ConfiCrtorWs.cdUsuroUltmaAlter" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import store from "@/store";
  
  import { 
  	
      } from "@/store/actions.type";
      
  export default {
    props: ['ssv2340ConfiCrtorWs', 'violations'],
    computed: {
  	    ...mapGetters([
  	         
  	         ]),
    },
    methods:{
        
    },
    mounted(){
      
    }
  }
</script>